'use client';

// Global error boundary. Next.js renders this when a server component
// throws or a client component bubbles an uncaught error past its
// own boundary. Keep it simple and recoverable — an action button
// resets the boundary, a "go home" link gives an out.

import Link from 'next/link';
import { useEffect } from 'react';

export default function GlobalError({ error, reset }: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Surface to the browser console so devtools-having visitors can
    // see what went wrong without us shipping a stack-trace UI.
    // eslint-disable-next-line no-console
    console.error('Unhandled error:', error);
  }, [error]);

  return (
    <main className="container-x py-24">
      <div className="max-w-xl">
        <span className="pill">Something went wrong</span>
        <h1 className="heading-1 mt-4">We hit an error rendering this page.</h1>
        <p className="text-lead mt-4">
          The infrastructure side is independent of this — your tokens still work. Try the
          retry button, or pick a known-good page from the nav above.
        </p>
        {error.digest && (
          <p className="mt-4 text-xs font-mono text-ink-faint">Trace ID: {error.digest}</p>
        )}
        <div className="mt-8 flex flex-wrap gap-3">
          <button onClick={reset} className="btn-primary text-sm">Try again</button>
          <Link href="/" className="btn-secondary text-sm">Home</Link>
        </div>
      </div>
    </main>
  );
}
